<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" date keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.Month" id="Month" label="預計隔幾個月進行追蹤">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in 12" :key="o" :value="o">{{o}} 個月後</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學號-學生姓名</th>
                            <th>預計隔幾個月進行追蹤</th>
                            <th>預計追蹤日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.HealthTrackingID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.HealthTrackingID" /></td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.HealthTrackingID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="預計隔幾個月進行追蹤">{{item.Month}}</td>
                        <td data-th="預計追蹤日期">{{item.NextTrackingDate|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload">
        </Detail>
    </page-main>
</template>

<script>
    import Detail from './healthtrackingNextDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'healthtrackingNext',
        api: '/api/healthtrackingNext/',
        components: { Detail },
        query: { Month: '', Syear: 0, Semester: '' }
    });
</script>

<style>
</style>